module.exports = __webpack_public_path__ + "assets/images/premium-features/enable-newsfeed-d52045.png";